// extracted by mini-css-extract-plugin
module.exports = {"title":"_403_title_260KY"};